(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-announcement-carousel')) {
    class MeAnnouncementCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.me-announcement__slide'));
        this.index = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
        this.onClick = (event) => {
          const button = event.target.closest('[data-dir]');
          if (!button) return;
          this.go(this.index + Number(button.dataset.dir));
          this.restart();
        };
        this.pause = () => this.stop();
        this.resume = () => this.start();
        this.addEventListener('click', this.onClick);
        this.addEventListener('mouseenter', this.pause);
        this.addEventListener('mouseleave', this.resume);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.resume);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.removeEventListener('click', this.onClick);
      }

      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const delay = Math.max(2, Number(this.dataset.speed) || 5) * 1000;
        this.timer = window.setInterval(() => this.go(this.index + 1), delay);
      }

      stop() {
        window.clearInterval(this.timer);
      }

      restart() {
        if (!this.matches(':hover, :focus-within')) this.start();
      }

      go(next) {
        const count = this.slides.length;
        if (count < 2) return;
        this.slides[this.index].hidden = true;
        this.slides[this.index].classList.remove('is-active');
        this.index = (next + count) % count;
        this.slides[this.index].hidden = false;
        this.slides[this.index].classList.add('is-active');
      }
    }

    customElements.define('me-announcement-carousel', MeAnnouncementCarousel);
  }

  document.addEventListener('shopify:block:select', (event) => {
    const carousel = event.target.closest && event.target.closest('me-announcement-carousel');
    if (!carousel || !carousel.slides) return;
    carousel.stop();
    carousel.go(carousel.slides.indexOf(event.target));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-article"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-article')) {
    class MeArticle extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-me-article-content]');
        this.bar = this.querySelector('[data-me-progress]');
        this.copyButton = this.querySelector('[data-me-copy]');
        this.copyStatus = this.querySelector('[data-me-copy-status]');

        if (this.bar && this.content) {
          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.updateProgress();
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.updateProgress();
        }

        this.setupToc();

        if (this.copyButton) {
          this.onCopy = () => this.copyLink();
          this.copyButton.addEventListener('click', this.onCopy);
        }
      }

      disconnectedCallback() {
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
        if (this.frame) cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.copyButton?.removeEventListener('click', this.onCopy);
        clearTimeout(this.statusTimer);
      }

      /* Progression = part du contenu de l'article déjà lue */
      updateProgress() {
        const rect = this.content.getBoundingClientRect();
        const total = rect.height - window.innerHeight * 0.6;
        const read = window.innerHeight * 0.4 - rect.top;
        const ratio = total > 0 ? Math.min(1, Math.max(0, read / total)) : rect.top < 0 ? 1 : 0;
        this.bar.style.setProperty('--me-progress', ratio.toFixed(4));
      }

      /* Les ancres existent déjà côté serveur : on ne fait que surligner la rubrique en cours */
      setupToc() {
        const links = Array.from(this.querySelectorAll('[data-me-toc-link]'));
        if (!links.length || !('IntersectionObserver' in window)) return;

        const byId = new Map(links.map((link) => [link.dataset.meTocLink, link]));
        const headings = links
          .map((link) => document.getElementById(link.dataset.meTocLink))
          .filter(Boolean);

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              links.forEach((link) => link.removeAttribute('aria-current'));
              byId.get(entry.target.id)?.setAttribute('aria-current', 'true');
            });
          },
          { rootMargin: '0px 0px -70% 0px' }
        );
        headings.forEach((heading) => this.observer.observe(heading));
      }

      async copyLink() {
        const url = this.copyButton.dataset.meCopy || window.location.href;
        const absolute = new URL(url, window.location.origin).href;
        let copied = false;

        try {
          await navigator.clipboard.writeText(absolute);
          copied = true;
        } catch (error) {
          const field = document.createElement('textarea');
          field.value = absolute;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.select();
          try {
            copied = document.execCommand('copy');
          } catch (fallbackError) {
            copied = false;
          }
          field.remove();
        }

        if (copied && this.copyStatus) {
          this.copyStatus.textContent = this.dataset.copiedLabel || '';
          clearTimeout(this.statusTimer);
          this.statusTimer = setTimeout(() => {
            this.copyStatus.textContent = '';
          }, 2500);
        }
      }
    }

    customElements.define('me-article', MeArticle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-collection-hero"] && !Shopify.designMode) return;
  try {
    
  /* « Lire la suite » : le texte complet reste dans le HTML (SEO), seul l'affichage est replié. */
  if (!customElements.get('me-read-more')) {
    customElements.define(
      'me-read-more',
      class MeReadMore extends HTMLElement {
        connectedCallback() {
          const content = this.querySelector('[data-read-more-content]');
          const toggle = this.querySelector('[data-read-more-toggle]');
          if (!content || !toggle) return;
          this.style.setProperty('--me-lines', this.dataset.lines || 3);
          this.setAttribute('data-collapsed', '');
          requestAnimationFrame(() => {
            if (content.scrollHeight <= content.clientHeight + 2) {
              this.removeAttribute('data-collapsed');
              return;
            }
            toggle.hidden = false;
            toggle.addEventListener('click', () => {
              const expanded = this.toggleAttribute('data-collapsed') === false;
              toggle.setAttribute('aria-expanded', String(expanded));
              toggle.querySelector('[data-label-more]').hidden = expanded;
              toggle.querySelector('[data-label-less]').hidden = !expanded;
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-collection-tabs')) {
    class MeCollectionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-me-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-me-tab-panel]'));
        this.tablist = this.querySelector('[data-me-tablist]');
        this.dot = this.querySelector('[data-me-tab-dot]');
        if (!this.tabs.length) return;

        this.onClick = (event) => {
          const tab = event.target.closest('[data-me-tab]');
          if (tab) this.select(this.tabs.indexOf(tab));
        };
        this.onKeydown = (event) => {
          const current = this.tabs.indexOf(document.activeElement);
          if (current < 0) return;
          const last = this.tabs.length - 1;
          const targets = {
            ArrowRight: current === last ? 0 : current + 1,
            ArrowLeft: current === 0 ? last : current - 1,
            Home: 0,
            End: last,
          };
          if (!(event.key in targets)) return;
          event.preventDefault();
          this.select(targets[event.key], true);
        };
        this.onBlockSelect = (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index >= 0) this.select(index);
        };

        this.tablist.addEventListener('click', this.onClick);
        this.tablist.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        this.resizeObserver = new ResizeObserver(() => this.moveDot());
        this.resizeObserver.observe(this.tablist);
        this.moveDot();
        document.fonts?.ready.then(() => this.moveDot());
      }

      disconnectedCallback() {
        this.tablist?.removeEventListener('click', this.onClick);
        this.tablist?.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
      }

      get activeIndex() {
        return Math.max(
          0,
          this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
        );
      }

      select(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
        const tab = this.tabs[index];
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        this.moveDot();
      }

      moveDot() {
        const tab = this.tabs[this.activeIndex];
        if (!this.dot || !tab) return;
        this.dot.style.setProperty('--me-dot-x', `${tab.offsetLeft}px`);
      }
    }

    customElements.define('me-collection-tabs', MeCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-cta-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-cta-banner')) {
    class MeCtaBanner extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = () => this.applyMotionPreference();
        this.motionQuery.addEventListener('change', this.onMotionChange);
        this.applyMotionPreference();
      }

      disconnectedCallback() {
        if (this.motionQuery) this.motionQuery.removeEventListener('change', this.onMotionChange);
      }

      applyMotionPreference() {
        if (this.motionQuery.matches) {
          this.video.removeAttribute('autoplay');
          this.video.pause();
        } else {
          this.video.setAttribute('autoplay', '');
          const playing = this.video.play();
          if (playing && typeof playing.catch === 'function') playing.catch(() => {});
        }
      }
    }

    customElements.define('me-cta-banner', MeCtaBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-diagnostic-launcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-diagnostic-launcher')) {
    const LAUNCHER_KEY = 'meDxLauncher';

    class MeDiagnosticLauncher extends HTMLElement {
      connectedCallback() {
        this.onScroll = this.onScroll.bind(this);
        this.onClose = this.onClose.bind(this);
        this.closeButton = this.querySelector('[data-launcher-close]');
        if (this.closeButton) this.closeButton.addEventListener('click', this.onClose);

        if (this.hasAttribute('data-design-mode')) {
          this.reveal();
          return;
        }

        const days = parseFloat(this.dataset.days || '3') || 3;
        try {
          const closedAt = parseInt(window.localStorage.getItem(LAUNCHER_KEY) || '0', 10);
          if (closedAt && Date.now() - closedAt < days * 86400000) return;
        } catch (error) {
          /* Stockage indisponible : on affiche quand même */
        }

        const delay = parseFloat(this.dataset.delay || '0');
        const scroll = parseInt(this.dataset.scroll || '0', 10);
        if (delay > 0) this.timer = window.setTimeout(() => this.reveal(), delay * 1000);
        if (scroll > 0) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        }
        if (delay <= 0 && scroll <= 0) this.reveal();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        window.clearTimeout(this.hideTimer);
        window.removeEventListener('scroll', this.onScroll);
        if (this.closeButton) this.closeButton.removeEventListener('click', this.onClose);
      }

      onScroll() {
        const threshold = parseInt(this.dataset.scroll || '0', 10);
        if (window.scrollY > threshold) this.reveal();
      }

      reveal() {
        if (this.shown) return;
        this.shown = true;
        window.clearTimeout(this.timer);
        window.removeEventListener('scroll', this.onScroll);
        this.hidden = false;
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => this.classList.add('is-in'));
        });
      }

      onClose(event) {
        event.preventDefault();
        event.stopPropagation();
        this.classList.remove('is-in');
        this.hideTimer = window.setTimeout(() => {
          this.hidden = true;
        }, 350);
        if (this.hasAttribute('data-design-mode')) return;
        try {
          window.localStorage.setItem(LAUNCHER_KEY, String(Date.now()));
        } catch (error) {
          /* Stockage indisponible : la bulle reviendra à la prochaine page */
        }
      }
    }

    customElements.define('me-diagnostic-launcher', MeDiagnosticLauncher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-diagnostic"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-diagnostic')) {
    const EYE_ICON =
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true" focusable="false"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="2.6"/></svg>';
    const STORAGE_RECO = 'meDxReco';
    const STORAGE_ANSWERS = 'meDxAnswers';

    const esc = (value) =>
      String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const fill = (template, values) =>
      String(template || '').replace(/\[(\w+)\]/g, (match, key) =>
        Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match
      );

    const slug = (value) =>
      String(value || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    const storage = (type) => {
      try {
        return window[type];
      } catch (error) {
        return null;
      }
    };

    class MeDiagnostic extends HTMLElement {
      connectedCallback() {
        const source = this.querySelector('[data-dx-data]');
        if (!source) return;
        try {
          this.data = JSON.parse(source.textContent);
        } catch (error) {
          return;
        }

        this.i18n = this.data.i18n || {};
        this.models = (this.data.models || [])
          .map((model, index) => Object.assign({ index }, model))
          .sort((a, b) => (a.priority - b.priority) || (a.index - b.index));
        this.byHandle = {};
        this.models.forEach((model) => {
          this.byHandle[model.handle] = model;
        });

        this.panel = this.querySelector('[data-dx-panel]');
        this.views = Array.from(this.querySelectorAll('[data-dx-view]'));
        this.intro = this.querySelector('[data-dx-view="intro"]');
        this.questions = Array.from(this.querySelectorAll('[data-dx-question]'));
        this.resultView = this.querySelector('[data-dx-result]');
        this.thanksView = this.querySelector('[data-dx-view="thanks"]');
        this.progress = this.querySelector('[data-dx-progress]');
        this.bar = this.querySelector('[data-dx-bar]');
        this.count = this.querySelector('[data-dx-count]');
        this.live = this.querySelector('[data-dx-live]');
        this.lead = this.querySelector('[data-dx-lead]');
        this.dialog = this.querySelector('[data-dx-dialog]');
        this.lbImg = this.querySelector('[data-dx-lb-img]');
        this.lbTitle = this.querySelector('[data-dx-lb-title]');
        this.lbCount = this.querySelector('[data-dx-lb-count]');
        this.total = this.questions.length;
        this.answers = {};
        this.step = -1;
        this.lbImages = [];
        this.lbIndex = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onClick = this.onClick.bind(this);
        this.onDialogKey = this.onDialogKey.bind(this);
        this.onDialogClick = this.onDialogClick.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.addEventListener('click', this.onClick);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        if (this.dialog) {
          this.dialog.addEventListener('keydown', this.onDialogKey);
          this.dialog.addEventListener('click', this.onDialogClick);
          this.dialog.addEventListener('close', this.onDialogClose);
        }

        this.boot();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.dialog) {
          this.dialog.removeEventListener('keydown', this.onDialogKey);
          this.dialog.removeEventListener('click', this.onDialogClick);
          this.dialog.removeEventListener('close', this.onDialogClose);
          if (this.dialog.open) this.dialog.close();
        }
      }

      boot() {
        const posted =
          this.querySelector('[data-dx-posted]') || /[?&]customer_posted=true/.test(window.location.search || '');
        if (posted && this.thanksView) {
          this.showThanks();
          return;
        }
        if (this.querySelector('[data-dx-errors]')) {
          const session = storage('sessionStorage');
          let saved = null;
          try {
            saved = session ? JSON.parse(session.getItem(STORAGE_ANSWERS) || 'null') : null;
          } catch (error) {
            saved = null;
          }
          if (saved && saved.effect && saved.eye && saved.color) {
            this.answers = saved;
            this.showResult(false);
            const email = this.querySelector('[data-dx-email]');
            if (email) email.focus();
            return;
          }
        }
        this.showIntro(false);
      }

      /* Éditeur de thème : afficher la question qui contient le bloc sélectionné */
      onBlockSelect(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target || !this.contains(target)) return;
        const question = target.closest('[data-dx-question]');
        if (question) this.goTo(this.questions.indexOf(question));
      }

      /* ---------- Navigation ---------- */
      onClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        if (target.closest('[data-dx-start]')) {
          this.goTo(0);
          return;
        }
        if (target.closest('[data-dx-back]')) {
          this.goTo(this.step - 1);
          return;
        }
        if (target.closest('[data-dx-restart]')) {
          this.answers = {};
          this.goTo(0);
          return;
        }
        const photos = target.closest('[data-dx-photos]');
        if (photos) {
          event.preventDefault();
          this.openLightbox(photos.getAttribute('data-dx-photos'), photos);
          return;
        }
        const choice = target.closest('[data-dx-value]');
        if (choice) {
          const question = choice.closest('[data-dx-question]');
          if (!question) return;
          this.answers[question.getAttribute('data-dx-question')] = choice.getAttribute('data-dx-value');
          if (this.step < this.total - 1) {
            this.goTo(this.step + 1);
          } else {
            this.showResult(true);
          }
        }
      }

      show(view, focus) {
        this.views.forEach((element) => {
          element.hidden = element !== view;
          element.classList.remove('is-entering');
        });
        if (this.lead) this.lead.hidden = view !== this.resultView;
        if (!view) return;
        if (!this.reduced) {
          void view.offsetWidth;
          view.classList.add('is-entering');
        }
        if (!focus) return;
        if (this.panel && this.panel.getBoundingClientRect().top < 0) {
          this.panel.scrollIntoView({ block: 'start', behavior: this.reduced ? 'auto' : 'smooth' });
        }
        const heading = view.querySelector('[data-dx-focus]');
        if (heading) heading.focus({ preventScroll: true });
      }

      setProgress(percent, label) {
        if (this.bar) this.bar.style.width = percent + '%';
        if (this.progress) this.progress.setAttribute('aria-valuenow', String(Math.round(percent)));
        if (this.count) this.count.textContent = label || '';
      }

      announce(text) {
        if (!this.live) return;
        this.live.textContent = '';
        window.requestAnimationFrame(() => {
          this.live.textContent = text;
        });
      }

      showIntro(focus) {
        this.step = -1;
        this.setProgress(0, '');
        this.show(this.intro, focus);
      }

      goTo(index) {
        if (index < 0) {
          this.showIntro(true);
          return;
        }
        const question = this.questions[index];
        if (!question) return;
        this.step = index;
        const current = String(index + 1);
        const total = String(this.total);
        this.setProgress((index / this.total) * 100, fill(this.i18n.counter, { current, total }));
        const back = question.querySelector('[data-dx-back]');
        if (back) back.hidden = index === 0;
        this.show(question, true);
        const heading = question.querySelector('[data-dx-focus]');
        this.announce(
          fill(this.i18n.stepAnnounce, { current, total, title: heading ? heading.textContent.trim() : '' })
        );
      }

      /* ---------- Recommandation (algorithme ALTO) ---------- */
      rank(list, curl) {
        return list
          .slice()
          .sort(
            (a, b) =>
              Number(b.curl === curl) - Number(a.curl === curl) || a.priority - b.priority || a.index - b.index
          );
      }

      recommend() {
        const eye = (this.data.eyes || {})[this.answers.eye] || {};
        const curl = eye.curl || 'C';
        const all = this.models;
        let byColor = all.filter((model) => model.color === this.answers.color);
        if (!byColor.length) byColor = all.slice();
        const byEffect = byColor.filter((model) => model.effect === this.answers.effect);
        const candidates = byEffect.length ? byEffect : byColor;
        const ordered = [];
        const seen = {};
        [candidates, byColor, all].forEach((list) => {
          this.rank(list, curl).forEach((model) => {
            if (seen[model.handle]) return;
            seen[model.handle] = true;
            ordered.push(model);
          });
        });
        return { best: ordered[0], alternatives: ordered.slice(1, 3), eye };
      }

      priceHtml(price, compare) {
        if (!price) return '';
        if (compare) {
          return (
            '<p class="me-dx__price"><span class="visually-hidden">' +
            esc(this.i18n.priceSale) +
            '</span><span class="me-dx__price-now">' +
            esc(price) +
            '</span><span class="visually-hidden">' +
            esc(this.i18n.priceRegular) +
            '</span><s class="me-dx__price-was">' +
            esc(compare) +
            '</s></p>'
          );
        }
        return '<p class="me-dx__price"><span class="me-dx__price-now">' + esc(price) + '</span></p>';
      }

      showResult(focus) {
        if (!this.resultView || !this.models.length) return;
        const { best, alternatives, eye } = this.recommend();
        if (!best) return;
        const t = this.i18n;
        const texts = this.data.texts || {};
        const looks = this.data.looks || {};
        const curls = this.data.curls || {};
        const effects = this.data.effects || {};

        const lookKeys = (eye.looks || []).filter((key) => looks[key]);
        const look = looks[lookKeys[0]] || null;
        const curl = curls[eye.curl] || null;
        const photoCount = best.imgs && best.imgs.length ? best.imgs.length : best.img ? 1 : 0;
        const photosLabel = fill(t.viewPhotos, { name: best.name });

        let html = '<div class="me-dx__res-top">';
        if (best.img) {
          html +=
            (photoCount
              ? '<button type="button" class="me-dx__res-media" data-dx-photos="' +
                esc(best.handle) +
                '" aria-haspopup="dialog" aria-label="' +
                esc(photosLabel) +
                '">'
              : '<div class="me-dx__res-media">') +
            '<img src="' +
            esc(best.img) +
            '" alt="' +
            esc(best.alt || best.name) +
            '" width="700" height="700">' +
            (photoCount > 1 ? '<span class="me-dx__zoom" aria-hidden="true">' + EYE_ICON + photoCount + '</span>' : '') +
            (photoCount ? '</button>' : '</div>');
        }
        html += '<div>';
        if (texts.resultEyebrow) html += '<p class="me-dx__res-eyebrow">' + esc(texts.resultEyebrow) + '</p>';
        html += '<h2 class="me-dx__res-name" tabindex="-1" data-dx-focus>' + esc(best.name) + '</h2>';
        if (best.label && best.label !== best.name) html += '<p class="me-dx__res-label">' + esc(best.label) + '</p>';
        const tags = [];
        if (effects[best.effect]) tags.push(esc(t.effect) + ' : ' + esc(effects[best.effect]));
        if (best.curl) tags.push(esc(t.curl) + ' ' + esc(best.curl));
        if (tags.length) html += '<ul class="me-dx__tags" role="list"><li>' + tags.join('</li><li>') + '</li></ul>';
        html +=
          '<div class="me-dx__res-cta"><a class="button" href="' +
          esc(best.url) +
          '" aria-label="' +
          esc(fill(t.viewModelLabel, { name: best.name })) +
          '">' +
          esc(t.viewModel) +
          '</a></div>';
        html += '</div></div>';

        /* Conseil de pose : regard (mapping) et courbure selon la forme d'yeux */
        if (look || curl || eye.objective || eye.avoid) {
          if (texts.adviceHeading) html += '<h3 class="me-dx__subhead">' + esc(texts.adviceHeading) + '</h3>';
          if (look || curl) {
            html += '<div class="me-dx__artist">';
            if (look) {
              html +=
                '<div class="me-dx__ac">' +
                (look.img ? '<img src="' + esc(look.img) + '" alt="" width="600" height="400" loading="lazy">' : '') +
                '<p class="me-dx__ac-t">' +
                esc(t.lookLabel) +
                '</p><p class="me-dx__ac-v">' +
                esc(look.name) +
                '</p>' +
                (look.effect ? '<p class="me-dx__ac-d">' + esc(look.effect) + '</p>' : '') +
                '</div>';
            }
            if (curl) {
              html +=
                '<div class="me-dx__ac">' +
                (curl.img ? '<img src="' + esc(curl.img) + '" alt="" width="450" height="300" loading="lazy">' : '') +
                '<p class="me-dx__ac-t">' +
                esc(t.curlLabel) +
                '</p><p class="me-dx__ac-v">' +
                esc(curl.name) +
                '</p>' +
                (curl.description ? '<p class="me-dx__ac-d">' + esc(curl.description) + '</p>' : '') +
                '</div>';
            }
            html += '</div>';
          }
          let tip = '';
          if (look) {
            tip = fill(t.tip, { shape: esc(String(eye.label || '').toLowerCase()), look: esc(look.name) });
            if (eye.objective) tip += ' &middot; ' + esc(eye.objective);
            tip += '.';
          } else if (eye.objective) {
            tip = esc(eye.objective);
          }
          if (eye.avoid) tip += ' ' + esc(eye.avoid);
          let tipHtml = tip ? '<p>' + tip + '</p>' : '';
          if (look && look.description) tipHtml += '<p>' + esc(look.description) + '</p>';
          if (lookKeys.length > 1) {
            const others = lookKeys
              .slice(1)
              .map((key) => esc(looks[key].name))
              .join(', ');
            tipHtml += '<p>' + fill(esc(t.alsoSuits), { looks: others }) + '</p>';
          }
          if (tipHtml) html += '<div class="me-dx__tip">' + tipHtml + '</div>';
        }

        /* Alternatives */
        if (alternatives.length) {
          if (texts.alternativesHeading) html += '<h3 class="me-dx__subhead">' + esc(texts.alternativesHeading) + '</h3>';
          html += '<ul class="me-dx__alts" role="list">';
          alternatives.forEach((model) => {
            html +=
              '<li class="me-dx__alt"><a class="me-dx__alt-link" href="' +
              esc(model.url) +
              '">' +
              (model.img
                ? '<img src="' + esc(model.img) + '" alt="" width="700" height="700" loading="lazy">'
                : '') +
              '<span class="me-dx__alt-name">' +
              esc(model.name) +
              (model.label && model.label !== model.name ? '<small>' + esc(model.label) + '</small>' : '') +
              '</span></a>' +
              (model.imgs && model.imgs.length
                ? '<button type="button" class="me-dx__eye" data-dx-photos="' +
                  esc(model.handle) +
                  '" aria-haspopup="dialog" aria-label="' +
                  esc(fill(t.viewPhotos, { name: model.name })) +
                  '">' +
                  EYE_ICON +
                  '</button>'
                : '') +
              '</li>';
          });
          html += '</ul>';
        }

        /* Packs : disponibles, kit.enabled, et contenant le modèle (kit.models vide = toujours) */
        const packs = (this.data.packs || []).filter(
          (pack) => !pack.models || !pack.models.length || pack.models.indexOf(best.handle) > -1
        );
        if (packs.length) {
          if (texts.packsHeading) html += '<h3 class="me-dx__subhead">' + esc(texts.packsHeading) + '</h3>';
          html += '<ul class="me-dx__packs" role="list">';
          packs.forEach((pack) => {
            const href = pack.url + (pack.url.indexOf('?') > -1 ? '&' : '?') + 'kit=' + encodeURIComponent(best.name);
            html +=
              '<li class="me-dx__pack">' +
              (pack.img
                ? '<div class="me-dx__pack-media"><img src="' +
                  esc(pack.img) +
                  '" alt="' +
                  esc(pack.alt) +
                  '" width="600" height="450" loading="lazy"></div>'
                : '') +
              '<div class="me-dx__pack-body"><p class="me-dx__pack-title">' +
              esc(pack.title) +
              '</p>' +
              (pack.boxes ? '<p class="me-dx__pack-boxes">' + esc(pack.boxes) + '</p>' : '') +
              this.priceHtml(pack.price, pack.compare) +
              (pack.savings ? '<p class="me-dx__savings">' + esc(pack.savings) + '</p>' : '') +
              '<a class="button" href="' +
              esc(href) +
              '" aria-label="' +
              esc(fill(t.composePackLabel, { pack: pack.title, name: best.name })) +
              '">' +
              esc(t.composePack) +
              '</a></div></li>';
          });
          html += '</ul>';
        } else {
          /* Aucun pack disponible : commande directe du modèle */
          if (texts.orderHeading) html += '<h3 class="me-dx__subhead">' + esc(texts.orderHeading) + '</h3>';
          html +=
            '<div class="me-dx__order">' +
            (best.img ? '<img src="' + esc(best.img) + '" alt="" width="700" height="700" loading="lazy">' : '') +
            '<div class="me-dx__order-body"><p class="me-dx__pack-title">' +
            esc(best.name) +
            '</p>' +
            this.priceHtml(best.price, best.compare);
          if (best.variantId) {
            html +=
              '<me-quick-add data-cart-url="' +
              esc(this.data.routes.cart) +
              '" data-added-text="' +
              esc(t.added) +
              '" data-error-text="' +
              esc(t.error) +
              '"><form action="' +
              esc(this.data.routes.cartAdd) +
              '" method="post"><input type="hidden" name="id" value="' +
              esc(best.variantId) +
              '"><input type="hidden" name="quantity" value="1"><button type="submit" class="button">' +
              esc(t.addToCart) +
              '</button></form><span class="visually-hidden" role="status" aria-live="polite" data-me-quick-add-status></span></me-quick-add>';
          } else {
            html +=
              '<a class="button" href="' +
              esc(best.url) +
              '" aria-label="' +
              esc(fill(t.viewModelLabel, { name: best.name })) +
              '">' +
              esc(t.viewModel) +
              '</a>';
          }
          html += '</div></div>';
        }

        html +=
          '<div class="me-dx__next"><button type="button" class="button-secondary" data-dx-restart>' +
          esc(t.restart) +
          '</button></div>';

        this.resultView.innerHTML = html;
        this.step = this.total;
        this.setProgress(100, t.counterResult);
        this.show(this.resultView, focus);
        this.announce(fill(t.resultAnnounce, { name: best.name }));

        /* Formulaire e-mail : tags « diagnostic,quiz-<modele> » */
        if (this.lead) {
          const tags = this.lead.querySelector('[data-dx-tags]');
          if (tags) {
            const base = (tags.getAttribute('data-base') || '').trim();
            const modelTag = 'quiz-' + slug(best.name);
            tags.value = base ? base + ',' + modelTag : modelTag;
          }
        }
        const local = storage('localStorage');
        const session = storage('sessionStorage');
        try {
          if (local) local.setItem(STORAGE_RECO, best.name);
          if (session) session.setItem(STORAGE_ANSWERS, JSON.stringify(this.answers));
        } catch (error) {
          /* Stockage indisponible : sans conséquence */
        }
      }

      showThanks() {
        let name = '';
        try {
          const local = storage('localStorage');
          name = local ? local.getItem(STORAGE_RECO) || '' : '';
        } catch (error) {
          name = '';
        }
        const text = this.thanksView.querySelector('[data-dx-thanks-text]');
        if (text) {
          const template = text.getAttribute('data-template') || '';
          text.textContent = name
            ? template.replace(/\[modele\]/g, name)
            : template.replace(/\s*\(\s*\[modele\]\s*\)|\s*\[modele\]/g, '');
        }
        this.step = this.total;
        this.setProgress(100, this.i18n.counterThanks);
        this.show(this.thanksView, false);
        if (this.lead) this.lead.hidden = true;
      }

      /* ---------- Lightbox ---------- */
      openLightbox(handle, trigger) {
        const model = this.byHandle[handle];
        if (!model || !this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.lbImages = model.imgs && model.imgs.length ? model.imgs : model.img ? [model.img] : [];
        if (!this.lbImages.length) return;
        this.lbModel = model;
        this.lbIndex = 0;
        this.lbTrigger = trigger || null;
        if (this.lbTitle) this.lbTitle.textContent = model.name;
        const single = this.lbImages.length < 2;
        this.dialog.querySelectorAll('[data-dx-lb-prev], [data-dx-lb-next]').forEach((button) => {
          button.hidden = single;
        });
        this.renderLightbox();
        this.dialog.showModal();
      }

      renderLightbox() {
        if (!this.lbImages.length) return;
        const number = String(this.lbIndex + 1);
        const total = String(this.lbImages.length);
        this.lbImg.src = this.lbImages[this.lbIndex];
        this.lbImg.alt = this.lbModel ? this.lbModel.name + ' – ' + number + ' / ' + total : '';
        if (this.lbCount) this.lbCount.textContent = fill(this.i18n.photoCounter, { number, total });
      }

      moveLightbox(direction) {
        if (this.lbImages.length < 2) return;
        this.lbIndex = (this.lbIndex + direction + this.lbImages.length) % this.lbImages.length;
        this.renderLightbox();
      }

      onDialogKey(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.moveLightbox(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.moveLightbox(1);
        }
      }

      onDialogClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        if (target.closest('[data-dx-lb-prev]')) return this.moveLightbox(-1);
        if (target.closest('[data-dx-lb-next]')) return this.moveLightbox(1);
        if (target.closest('[data-dx-lb-close]') || target === this.dialog || target.hasAttribute('data-dx-lb')) {
          this.dialog.close();
        }
      }

      onDialogClose() {
        if (this.lbTrigger && document.contains(this.lbTrigger)) this.lbTrigger.focus();
        this.lbTrigger = null;
      }
    }

    customElements.define('me-diagnostic', MeDiagnostic);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-faq')) {
    class MeFaq extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-me-faq-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-me-faq-panel]'));
        if (!this.tabs.length) return;

        this.onClick = (event) => {
          const tab = event.target.closest('[data-me-faq-tab]');
          if (tab) this.select(tab, false);
        };
        this.onKeydown = (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index === -1) return;
          let next = null;
          switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              next = this.tabs[(index + 1) % this.tabs.length];
              break;
            case 'ArrowLeft':
            case 'ArrowUp':
              next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
              break;
            case 'Home':
              next = this.tabs[0];
              break;
            case 'End':
              next = this.tabs[this.tabs.length - 1];
              break;
            default:
              return;
          }
          event.preventDefault();
          this.select(next, true);
        };
        // Éditeur de thème : sélectionner un bloc ouvre son onglet / sa question
        this.onBlockSelect = (event) => {
          const target = event.target;
          if (!this.contains(target)) return;
          if (target.matches('[data-me-faq-tab]')) this.select(target, false);
          const details = target.closest('details');
          if (details) {
            const panel = details.closest('[data-me-faq-panel]');
            const tab = panel && this.tabs.find((t) => t.getAttribute('aria-controls') === panel.id);
            if (tab) this.select(tab, false);
            details.open = true;
          }
        };

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(tab, focus) {
        const panelId = tab.getAttribute('aria-controls');
        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          const active = panel.id === panelId;
          if (active && panel.hidden) {
            panel.hidden = false;
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          } else if (!active) {
            panel.hidden = true;
            panel.querySelectorAll('details[open]').forEach((details) => (details.open = false));
          }
        });
        if (focus) tab.focus();
      }
    }

    customElements.define('me-faq', MeFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-hero-words')) {
    class MeHeroWords extends HTMLElement {
      connectedCallback() {
        this.words = (this.dataset.words || '')
          .split(',')
          .map((word) => word.trim())
          .filter(Boolean);
        this.target = this.querySelector('em') || this;
        this.index = 0;
        if (this.words.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = window.setInterval(() => this.cycle(), 3100);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        window.clearTimeout(this.swap);
      }

      cycle() {
        this.classList.add('is-out');
        this.swap = window.setTimeout(() => {
          this.style.transition = 'none';
          this.classList.remove('is-out');
          this.classList.add('is-in');
          this.index = (this.index + 1) % this.words.length;
          this.target.textContent = this.words[this.index];
          this.getBoundingClientRect();
          this.style.transition = '';
          requestAnimationFrame(() => this.classList.remove('is-in'));
        }, 500);
      }
    }

    customElements.define('me-hero-words', MeHeroWords);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-order-tracking"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-order-tracking')) {
    class MeOrderTracking extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.form = this.querySelector('[data-form]');
        this.input = this.querySelector('[data-input]');
        this.errorEl = this.querySelector('[data-error]');
        this.badge = this.querySelector('[data-badge]');
        this.badgeName = this.querySelector('[data-badge-name]');
        this.live = this.querySelector('[data-live]');
        this.searchPanel = this.querySelector('[data-search-panel]');
        this.result = this.querySelector('[data-result]');
        if (!this.form || !this.input || !this.result) return;

        this.carriers = Array.from(this.querySelectorAll('[data-carrier]')).map((el) => ({
          name: el.dataset.name || '',
          regex: this.compile(el.dataset.pattern),
          url: el.dataset.url || '',
          isDefault: el.dataset.default === 'true',
          logo: el.querySelector('img'),
        }));

        const steps = this.querySelectorAll('.me-order-tracking__step').length;
        if (steps) this.style.setProperty('--me-ot-steps', steps);

        this.lastDetected = null;
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.search(true);
        }, { signal });
        this.input.addEventListener('input', () => this.onInput(), { signal });
        this.querySelector('[data-reset]')?.addEventListener('click', () => this.reset(), { signal });

        const fromUrl = new URLSearchParams(window.location.search).get('tracking');
        if (fromUrl) {
          this.input.value = fromUrl;
          this.search(false);
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      compile(pattern) {
        if (!pattern) return null;
        try {
          return new RegExp(pattern, 'i');
        } catch (error) {
          return null;
        }
      }

      normalize(value) {
        return (value || '').replace(/\s+/g, '').toUpperCase();
      }

      detect(number) {
        if (!number) return null;
        return this.carriers.find((carrier) => carrier.regex && carrier.url && carrier.regex.test(number)) || null;
      }

      buildUrl(template, number) {
        const encoded = encodeURIComponent(number);
        const token = /\[number\]|\{\{\s*number\s*\}\}/;
        return token.test(template) ? template.replace(new RegExp(token.source, 'g'), encoded) : template + encoded;
      }

      setError(message) {
        this.errorEl.textContent = message || '';
        if (message) {
          this.input.setAttribute('aria-invalid', 'true');
        } else {
          this.input.removeAttribute('aria-invalid');
        }
      }

      onInput() {
        this.setError('');
        const detected = this.detect(this.normalize(this.input.value));
        if (detected === this.lastDetected) return;
        this.lastDetected = detected;
        if (detected) {
          this.badgeName.textContent = detected.name;
          this.badge.hidden = false;
          this.live.textContent = (this.dataset.detected || '').replace('[carrier]', detected.name);
        } else {
          this.badge.hidden = true;
          this.live.textContent = '';
        }
      }

      search(moveFocus) {
        const number = this.normalize(this.input.value);
        if (!number) {
          this.setError(this.dataset.errorEmpty);
          if (moveFocus) this.input.focus();
          return;
        }

        const detected = this.detect(number);
        const carrier = detected || this.carriers.find((item) => item.isDefault && item.url) || null;
        if (!carrier) {
          this.setError(this.dataset.errorUnknown);
          if (moveFocus) this.input.focus();
          return;
        }

        this.setError('');
        this.querySelector('[data-carrier-name]').textContent = carrier.name;
        this.querySelector('[data-number]').textContent = number;
        this.querySelector('[data-universal]').hidden = Boolean(detected);
        this.querySelector('[data-link]').href = this.buildUrl(carrier.url, number);

        const logoSlot = this.querySelector('[data-logo]');
        logoSlot.replaceChildren();
        if (carrier.logo) {
          const logo = carrier.logo.cloneNode(true);
          logo.loading = 'eager';
          logoSlot.append(logo);
          logoSlot.hidden = false;
        } else {
          logoSlot.hidden = true;
        }

        this.searchPanel.hidden = true;
        this.result.hidden = false;

        if (moveFocus) {
          this.result.focus({ preventScroll: true });
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.result.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      }

      reset() {
        this.result.hidden = true;
        this.searchPanel.hidden = false;
        this.input.value = '';
        this.lastDetected = null;
        this.badge.hidden = true;
        this.live.textContent = '';
        this.setError('');
        this.input.focus();
      }
    }

    customElements.define('me-order-tracking', MeOrderTracking);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-pdp-transformation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-me-pdp-ba-top]');
    if (!link) return;
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-product-slider')) {
    class MeProductSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-me-slider-track]');
        this.prev = this.querySelector('[data-me-slider-prev]');
        this.next = this.querySelector('[data-me-slider-next]');
        this.progress = this.querySelector('[data-me-slider-progress]');
        if (!this.track) return;

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);

        this.resizeObserver = new ResizeObserver(() => {
          this.placeArrows();
          this.update();
        });
        this.resizeObserver.observe(this.track);

        this.placeArrows();
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      get step() {
        const item = this.track.firstElementChild;
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      go(direction) {
        const step = this.step;
        const perPage = Math.max(1, Math.floor((this.track.clientWidth + 1) / step));
        this.track.scrollBy({
          left: direction * step * perPage,
          behavior: this.reduceMotion.matches ? 'auto' : 'smooth',
        });
      }

      /* Centre les flèches sur la hauteur des visuels, pas sur toute la carte */
      placeArrows() {
        const media = this.track.querySelector('.me-card__media');
        const viewport = this.track.parentElement;
        if (!media || !viewport) return;
        const top = media.getBoundingClientRect().top - viewport.getBoundingClientRect().top;
        viewport.style.setProperty('--me-arrow-top', `${Math.round(top + media.offsetHeight / 2)}px`);
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const scrollable = max > 2;
        this.toggleAttribute('data-scrollable', scrollable);

        const position = Math.abs(this.track.scrollLeft);
        if (this.prev) this.prev.disabled = !scrollable || position <= 2;
        if (this.next) this.next.disabled = !scrollable || position >= max - 2;

        if (this.progress && scrollable) {
          const size = this.track.clientWidth / this.track.scrollWidth;
          this.progress.style.setProperty('--me-progress-size', size.toFixed(4));
          this.progress.style.setProperty('--me-progress-pos', (position / max).toFixed(4));
        }
      }
    }

    customElements.define('me-product-slider', MeProductSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-steps')) {
    class MeSteps extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video.me-steps__video'));
        if (!this.videos.length) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.videos.forEach((video) => {
          video.muted = true;
          if (reduceMotion) video.controls = true;
        });
        // Mouvement réduit : pas de lecture automatique, contrôles natifs à la place
        if (reduceMotion || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              const item = video.closest('.me-steps__item');
              if (entry.isIntersecting) {
                const promise = video.play();
                if (promise && typeof promise.catch === 'function') promise.catch(() => {});
                if (item) item.classList.add('is-playing');
              } else {
                video.pause();
                if (item) item.classList.remove('is-playing');
              }
            });
          },
          { threshold: 0.5 }
        );
        this.videos.forEach((video) => this.observer.observe(video));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.videos) this.videos.forEach((video) => video.pause());
      }
    }

    customElements.define('me-steps', MeSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-video-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-video-sound')) {
    class MeVideoSound extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('[data-me-vb-sound]');
        if (!this.video) return;

        this.label = this.querySelector('[data-me-vb-sound-label]');
        this.video.muted = true;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.visible = false;

        this.onClick = this.onClick.bind(this);
        this.sync = this.sync.bind(this);
        if (this.button) this.button.addEventListener('click', this.onClick);
        this.video.addEventListener('volumechange', this.sync);

        // Mouvement réduit : pas de lecture automatique, contrôles natifs à la place
        if (this.reduceMotion) this.video.controls = true;
        if (!this.reduceMotion && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              this.visible = entries[0].isIntersecting;
              if (this.visible) this.play();
              else this.video.pause();
            },
            { threshold: 0.35 }
          );
          this.observer.observe(this);
        }
        this.sync();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.button) this.button.removeEventListener('click', this.onClick);
        if (this.video) {
          this.video.removeEventListener('volumechange', this.sync);
          this.video.pause();
        }
      }

      play() {
        const promise = this.video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      }

      onClick() {
        if (this.video.muted) {
          this.video.muted = false;
          if (this.video.volume === 0) this.video.volume = 1;
          this.play();
        } else {
          this.video.muted = true;
        }
        this.sync();
      }

      sync() {
        if (!this.button) return;
        const soundOn = !this.video.muted && this.video.volume > 0;
        this.button.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
        if (this.label) {
          this.label.textContent = soundOn ? this.button.dataset.labelMute : this.button.dataset.labelUnmute;
        }
      }
    }

    customElements.define('me-video-sound', MeVideoSound);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  class StickyAddToCart {
    constructor() {
      this.element = document.querySelector('[data-sticky-add-to-cart]');
      this.mainAddToCartButton = this.findMainAddToCartButton();
      this.destroyed = false;
      this.intervals = [];
      this.observers = [];
      
      if (!this.element) return;

      this.init();
    }

    destroy() {
      this.destroyed = true;
      this.intervals.forEach(id => clearInterval(id));
      this.intervals = [];
      this.observers.forEach(obs => obs.disconnect());
      this.observers = [];
      if (this.quantityBreaksObserver) {
        this.quantityBreaksObserver.disconnect();
        this.quantityBreaksObserver = null;
      }
      if (this.animationObserver) {
        this.animationObserver.disconnect();
        this.animationObserver = null;
      }
      if (this.quantityBreaksClickHandler) {
        document.removeEventListener('click', this.quantityBreaksClickHandler);
      }
    }

    findMainAddToCartButton() {
      // Look for the main add to cart button in various possible locations
      const selectors = [
        '.buy-buttons-block .add-to-cart-button',
        '.product-form-buttons .add-to-cart-button',
        '.product-details .add-to-cart-button',
        '[data-testid="product-information-details"] .add-to-cart-button',
        'product-form-component .add-to-cart-button',
        'form[data-type="add-to-cart-form"] button[type="submit"]',
        '.product-form button[type="submit"]',
        '.add-to-cart-button',
        'button[name="add"]'
      ];
      
      for (const selector of selectors) {
        const button = document.querySelector(selector);
        if (button) return button;
      }
      
      return null;
    }

    init() {
      this.setupScrollListener();
      this.setupPriceUpdates();
      this.setupPriceObserver();
      this.setupVariantsDisplay();
      this.setupVisibilityClasses();
      this.setupThemeEditorUpdates();
      this.setupVariantLinkClick();
      this.setupStickyButtonClick();
      this.setupButtonStateSync();
      this.setupQuantityBreaksListener();
      this.setupQuantityUpdates();
      
      // Initialize compact class
      this.updateCompactClass();
      
      // Get initial quantity after a short delay to ensure DOM is ready
      setTimeout(() => {
        this.currentQuantity = this.getInitialQuantity();
        this.updateButtonText();
      }, 100);
      
      // Also update on DOMContentLoaded if not already loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.currentQuantity = this.getInitialQuantity();
          this.updateButtonText();
        });
      }
      
      // Initialize image with current variant
      this.updateImage();
      
      // Check main button visibility immediately
      this.updateVisibility();
      
      // Check for quantity breaks price on initial load
      setTimeout(() => this.updatePriceFromQuantityBreaks(), 100);
    }


    isMainAddToCartVisible() {
      if (!this.mainAddToCartButton) return false;
      
      const rect = this.mainAddToCartButton.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Check if the main button is visible in the viewport
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= windowHeight &&
        rect.right <= window.innerWidth
      );
    }

    setupPriceUpdates() {
      // Listen for variant selected events (from variant picker)
      document.addEventListener('variant:selected', (event) => {
        this.updatePriceFromVariantId(event.detail.resource.id);
        this.updateImage();
      });

      // Listen for variant update events - this is the main event with full variant data
      document.addEventListener('variant:update', (event) => {
        // The variant data is in event.detail.resource
        const variant = event.detail.resource;
        if (variant) {
          this.updatePrice(variant);
          this.updateImageFromVariant(variant);
        } else {
          this.copyPriceFromMain();
          this.updateImage();
        }
      });

      // The main variant:update event should handle most cases
      // Keep a simple fallback for any missed events
      document.addEventListener('change', (event) => {
        if (event.target.name === 'id' && event.target.closest('form[data-type="add-to-cart-form"]')) {
          this.updatePriceFromVariantId(event.target.value);
          this.updateImage();
        }
      });
    }

    setupQuantityBreaksListener() {
      // Listen for clicks on quantity break cards
      this.quantityBreaksClickHandler = (event) => {
        const clickedCard = event.target.closest('.quantity-breaks__card');
        if (clickedCard) {
          setTimeout(() => this.updatePriceFromQuantityBreaks(), 50);
        }
      };
      document.addEventListener('click', this.quantityBreaksClickHandler);
      
      // Watch for active class changes on quantity break cards
      const quantityBreaksComponent = document.querySelector('[data-quantity-breaks-component]');
      if (quantityBreaksComponent) {
        this.quantityBreaksObserver = new MutationObserver(() => {
          if (this.destroyed) return;
          this.updatePriceFromQuantityBreaks();
        });
        
        this.quantityBreaksObserver.observe(quantityBreaksComponent, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    updatePriceFromQuantityBreaks() {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      // Check if price override is enabled in sticky-add-to-cart
      const stickyOverrideEnabled = this.element.dataset.overrideProductPrice === 'true';
      if (!stickyOverrideEnabled) return;

      const quantityBreaksComponent = document.querySelector('[data-quantity-breaks-component]');
      if (!quantityBreaksComponent) return;

      const activeCard = quantityBreaksComponent.querySelector('.quantity-breaks__card--active');
      if (!activeCard) return;

      const quantityPriceElement = activeCard.querySelector('.quantity-breaks__price');
      const quantityComparePriceElement = activeCard.querySelector('.quantity-breaks__original-price');
      
      if (!quantityPriceElement) return;

      const priceElement = this.element.querySelector('[data-sticky-price]');
      if (!priceElement) return;

      // Get show_sale_price_first setting
      const showSalePriceFirst = priceElement.dataset.showSalePriceFirst === 'true';

      // Update only the price values, preserving price-split markup (strip per-unit label clone)
      const priceContainer = priceElement.querySelector('[ref="priceContainer"]') || priceElement;
      const currentPriceSpan = priceContainer.querySelector('.price') || priceElement.querySelector('.price');
      
      // Find ALL compare price elements to handle duplicates
      // Check both in priceContainer and priceElement to catch all instances
      const containerComparePrices = priceContainer.querySelectorAll('.compare-at-price');
      const elementComparePrices = priceElement.querySelectorAll('.compare-at-price');
      const allComparePriceSpans = [];
      
      // Collect all unique compare price elements
      containerComparePrices.forEach(span => allComparePriceSpans.push(span));
      elementComparePrices.forEach(span => {
        if (!priceContainer.contains(span) && !allComparePriceSpans.includes(span)) {
          allComparePriceSpans.push(span);
        }
      });
      
      if (currentPriceSpan) {
        const priceClone = quantityPriceElement.cloneNode(true);
        priceClone.querySelectorAll('.quantity-breaks__per-unit-text').forEach((el) => el.remove());
        currentPriceSpan.innerHTML = priceClone.innerHTML.trim();
        if (!quantityComparePriceElement) {
          currentPriceSpan.style.marginLeft = '';
        }
      }

      if (quantityComparePriceElement) {
        allComparePriceSpans.forEach(compareSpan => {
          compareSpan.remove();
        });

        const comparePriceSpan = document.createElement('span');
        comparePriceSpan.className = 'compare-at-price price--compare';
        const compareClone = quantityComparePriceElement.cloneNode(true);
        compareClone.querySelectorAll('.quantity-breaks__per-unit-text').forEach((el) => el.remove());
        comparePriceSpan.innerHTML = compareClone.innerHTML.trim();
        
        // Set margin based on show_sale_price_first setting
        if (showSalePriceFirst) {
          comparePriceSpan.style.marginLeft = 'var(--margin-xs, 0.5rem)';
        } else {
          comparePriceSpan.style.marginLeft = '';
          if (currentPriceSpan) {
            currentPriceSpan.style.marginLeft = 'var(--margin-xs, 0.5rem)';
          }
        }
        
        // Respect show_sale_price_first setting for positioning
        if (currentPriceSpan) {
          if (showSalePriceFirst) {
            // Sale price first: price comes before compare price
            currentPriceSpan.insertAdjacentElement('afterend', comparePriceSpan);
          } else {
            // Compare price first: compare price comes before price
            currentPriceSpan.insertAdjacentElement('beforebegin', comparePriceSpan);
          }
        } else {
          priceContainer.appendChild(comparePriceSpan);
        }
      } else {
        // If compare price doesn't exist in quantity breaks but exists in sticky price, remove all of them
        allComparePriceSpans.forEach(compareSpan => {
          compareSpan.remove();
        });
        
        // Reset margin on price span when compare price is removed
        if (currentPriceSpan) {
          currentPriceSpan.style.marginLeft = '';
        }
      }
    }

    // Removed complex observers since we're using the main event system


    setupVariantsDisplay() {
      // Initialize variants display
      this.updateVariantsDisplay();
      
      // Listen for variant changes to update variants display
      document.addEventListener('variant:update', (event) => {
        this.updateVariantsDisplay();
      });
    }

    setupVariantLinkClick() {
      // Use event delegation to handle clicks on variant links (and descendants like SVG icon)
      this.element.addEventListener('click', (event) => {
        if (event.target.matches('[data-scroll-to-variants]') || event.target.closest('[data-scroll-to-variants]')) {
          event.preventDefault();
          this.scrollToVariantSelector();
        }
      });
    }

    setupStickyButtonClick() {
      // Handle clicks on the sticky add to cart button
      this.element.addEventListener('click', (event) => {
        if (event.target.matches('[data-sticky-add-to-cart-button]') || 
            event.target.closest('[data-sticky-add-to-cart-button]')) {
          event.preventDefault();
          this.triggerMainAddToCart();
        }
      });
    }

    triggerMainAddToCart() {
      if (!this.mainAddToCartButton) {
        console.warn('Main add to cart button not found');
        return;
      }

      // Check if the main button is disabled
      if (this.mainAddToCartButton.disabled) {
        return;
      }

      // Also check if the sticky button itself is disabled
      const stickyButton = this.element.querySelector('[data-sticky-add-to-cart-button]');
      if (stickyButton && stickyButton.disabled) {
        return;
      }

      if (this.hasQuantityBreaksWithDiscount()) {
        stickyButton.classList.add('loading');
      }

      // Trigger the main add to cart button click
      this.mainAddToCartButton.click();
    }

    hasQuantityBreaksWithDiscount() {
      const quantityBreaksEl = document.querySelector('[data-quantity-breaks-component]');
      const activeCard = quantityBreaksEl?.querySelector('.quantity-breaks__card--active');
      return !!activeCard?.dataset?.discountCode?.trim?.();
    }

    setupButtonStateSync() {
      // Sync the sticky button state with the main button state
      this.syncButtonState();
      
      // Listen for variant changes to update button state
      document.addEventListener('variant:update', (event) => {
        this.syncButtonState();
      });
      
      // Listen for variant selected events
      document.addEventListener('variant:selected', (event) => {
        this.syncButtonState();
      });
      
      // Also listen for form changes
      document.addEventListener('change', (event) => {
        if (event.target.name === 'id' && event.target.closest('form[data-type="add-to-cart-form"]')) {
          this.syncButtonState();
        }
      });
      
      // Add a small delay to ensure DOM is fully rendered
      setTimeout(() => {
        this.syncButtonState();
      }, 100);
      
      // Setup animation sync
      this.setupAnimationSync();
    }

    syncButtonState() {
      const stickyButton = this.element.querySelector('[data-sticky-add-to-cart-button]');
      if (!stickyButton) return;

      if (this.mainAddToCartButton) {
        // Sync disabled state
        stickyButton.disabled = this.mainAddToCartButton.disabled;
        
        // Sync button text
        const mainButtonText = this.getMainButtonText();
        const stickyButtonTextElement = stickyButton.querySelector('.add-to-cart-text__content');
        if (stickyButtonTextElement && mainButtonText) {
          stickyButtonTextElement.textContent = mainButtonText;
        }
        
        // Sync icon visibility
        const stickyIcon = stickyButton.querySelector('.add-to-cart-icon');
        const mainIcon = this.mainAddToCartButton.querySelector('.add-to-cart-icon');
        
        if (stickyIcon) {
          if (mainIcon) {
            // Check if main icon is visible (not hidden by CSS or display:none)
            const mainIconComputedStyle = window.getComputedStyle(mainIcon);
            const isMainIconVisible = mainIconComputedStyle.display !== 'none' && 
                                     mainIconComputedStyle.visibility !== 'hidden' &&
                                     mainIconComputedStyle.opacity !== '0';
            
            // Show sticky icon if main icon is visible, hide if not
            stickyIcon.style.display = isMainIconVisible ? 'inline' : 'none';
          } else {
            // No main icon found - check if main button is disabled
            // If main button is disabled, hide icon; if enabled, show icon
            stickyIcon.style.display = this.mainAddToCartButton.disabled ? 'none' : 'inline';
          }
        }
      } else {
        // Fallback: if main button not found, check if sticky button should be disabled based on initial state
        // The sticky button's initial disabled state should already be correct from Liquid
        // Just ensure the icon visibility matches the disabled state
        const stickyIcon = stickyButton.querySelector('.add-to-cart-icon');
        if (stickyIcon) {
          stickyIcon.style.display = stickyButton.disabled ? 'none' : 'inline';
        }
      }
      
      // Update quantity display
      this.updateButtonText();
    }
    
    setupQuantityUpdates() {
      // Listen for quantity selector update events
      // The event name is 'quantity-selector:update' (with hyphen)
      document.addEventListener('quantity-selector:update', (event) => {
        // Only respond to product page quantity selector updates, not cart drawer
        if (event.detail && event.detail.cartLine) return;
        
        this.currentQuantity = (event.detail && event.detail.quantity) ? parseInt(event.detail.quantity) : 1;
        this.updateButtonText();
      });
      
      // Also listen for ThemeEvents if available (for compatibility)
      if (window.ThemeEvents && window.ThemeEvents.quantitySelectorUpdate) {
        document.addEventListener(window.ThemeEvents.quantitySelectorUpdate, (event) => {
          if (event.detail && event.detail.cartLine) return;
          this.currentQuantity = (event.detail && event.detail.quantity) ? parseInt(event.detail.quantity) : 1;
          this.updateButtonText();
        });
      }
      
      // Also listen for direct input changes as a fallback
      const quantityInput = document.querySelector('quantity-selector-component input[type="number"], input[name="quantity"]');
      if (quantityInput) {
        quantityInput.addEventListener('change', () => {
          this.currentQuantity = parseInt(quantityInput.value) || 1;
          this.updateButtonText();
        });
        quantityInput.addEventListener('input', () => {
          this.currentQuantity = parseInt(quantityInput.value) || 1;
          this.updateButtonText();
        });
      }
    }
    
    getInitialQuantity() {
      // Try to get initial quantity from quantity selector component
      const quantitySelector = document.querySelector('quantity-selector-component');
      if (quantitySelector) {
        const quantityInput = quantitySelector.querySelector('input[type="number"]');
        if (quantityInput) {
          return parseInt(quantityInput.value) || 1;
        }
        // Try to get value from component method if available
        if (quantitySelector.getValue && typeof quantitySelector.getValue === 'function') {
          const value = quantitySelector.getValue();
          if (value) return parseInt(value) || 1;
        }
      }
      
      // Try to get from form
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        const quantityInput = form.querySelector('input[name="quantity"]');
        if (quantityInput) {
          return parseInt(quantityInput.value) || 1;
        }
      }
      
      return 1;
    }
    
    updateButtonText() {
      const stickyButton = this.element.querySelector('[data-sticky-add-to-cart-button]');
      if (!stickyButton) return;
      
      const quantityDisplay = stickyButton.querySelector('[data-quantity-display], [ref="quantityDisplay"]');
      const quantityNumber = stickyButton.querySelector('[data-quantity-number], [ref="quantityNumber"]');
      
      if (!quantityDisplay || !quantityNumber) return;
      
      const available = !stickyButton.disabled;
      const quantity = this.currentQuantity || 1;
      
      // Update the quantity number
      quantityNumber.textContent = quantity.toString();
      
      // Show/hide the quantity display based on availability and quantity
      if (available && quantity > 1) {
        quantityDisplay.style.display = 'inline';
      } else {
        quantityDisplay.style.display = 'none';
      }
    }

    getMainButtonText() {
      if (!this.mainAddToCartButton) return null;
      
      const textElement = this.mainAddToCartButton.querySelector('.add-to-cart-text__content');
      return textElement ? textElement.textContent.trim() : null;
    }

    debugIconState() {
      const stickyButton = this.element.querySelector('[data-sticky-add-to-cart-button]');
      const stickyIcon = stickyButton?.querySelector('.add-to-cart-icon');
      const mainIcon = this.mainAddToCartButton?.querySelector('.add-to-cart-icon');
      
      console.log('Icon Debug:', {
        stickyButtonDisabled: stickyButton?.disabled,
        mainButtonDisabled: this.mainAddToCartButton?.disabled,
        stickyIconExists: !!stickyIcon,
        mainIconExists: !!mainIcon,
        stickyIconDisplay: stickyIcon?.style.display,
        mainIconDisplay: mainIcon?.style.display,
        mainIconComputedDisplay: mainIcon ? window.getComputedStyle(mainIcon).display : 'N/A'
      });
    }

    setupAnimationSync() {
      if (!this.mainAddToCartButton) return;

      // Animation duration constant (same as in product-form.js)
      const ADD_TO_CART_TEXT_ANIMATION_DURATION = 2000;
      const stickyButton = this.element.querySelector('[data-sticky-add-to-cart-button]');
      if (!stickyButton) return;

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type !== 'attributes') return;
          const target = mutation.target;
          const stickyBtn = this.element.querySelector('[data-sticky-add-to-cart-button]');
          if (!stickyBtn) return;

          if (mutation.attributeName === 'data-added') {
            if (target.dataset.added === 'true') {
              if (stickyBtn.dataset.added !== 'true') {
                stickyBtn.dataset.added = 'true';
                setTimeout(() => stickyBtn.removeAttribute('data-added'), ADD_TO_CART_TEXT_ANIMATION_DURATION);
              }
            } else if (stickyBtn.dataset.added === 'true') {
              stickyBtn.removeAttribute('data-added');
            }
          } else if (mutation.attributeName === 'class' && this.hasQuantityBreaksWithDiscount()) {
            const mainHasLoading = this.mainAddToCartButton.classList.contains('loading');
            if (mainHasLoading) {
              stickyBtn.classList.add('loading');
            } else {
              stickyBtn.classList.remove('loading');
            }
          }
        });
      });

      observer.observe(this.mainAddToCartButton, {
        attributes: true,
        attributeFilter: ['data-added', 'class']
      });

      this.animationObserver = observer;
    }

    scrollToVariantSelector() {
      // Try to find variant selector in various possible locations
      const variantSelectors = [
        '.product-variants',
        '.variant-picker',
        '.product-options',
        '.product-form__options',
        '[data-testid="product-information-details"] .variant-picker',
        '.product-details .variant-picker',
        '.buy-buttons-block .variant-picker',
        'variant-picker'
      ];

      let targetElement = null;
      
      for (const selector of variantSelectors) {
        targetElement = document.querySelector(selector);
        if (targetElement) break;
      }

      if (targetElement) {
        // Scroll to the variant selector with smooth behavior
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        
        // Add a temporary highlight effect
        targetElement.style.transition = 'box-shadow 0.3s ease';
        targetElement.style.boxShadow = '0 0 0 2px var(--color-primary, #007bff)';
        
        // Remove highlight after 2 seconds
        setTimeout(() => {
          targetElement.style.boxShadow = '';
        }, 2000);
      } else {
        // Fallback: scroll to the main product form
        const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
        if (productForm) {
          productForm.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }

    setupVisibilityClasses() {
      // Add classes for browsers that don't support :has() selector
      const content = this.element.querySelector('.sticky-add-to-cart__content');
      if (!content) return;

      // Check which elements are present and add appropriate classes
      if (!content.querySelector('.sticky-add-to-cart__image')) {
        content.classList.add('no-image');
      }
      if (!content.querySelector('.sticky-add-to-cart__title')) {
        content.classList.add('no-title');
      }
      if (!content.querySelector('.sticky-add-to-cart__variants')) {
        content.classList.add('no-variants');
      }
      if (!content.querySelector('.sticky-add-to-cart__price')) {
        content.classList.add('no-price');
      }
    }

    setupThemeEditorUpdates() {
      // Also listen for any changes to the section element (when section is updated in-place)
      const observer = new MutationObserver((mutations) => {
        if (this.destroyed) return;
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && 
              (mutation.attributeName === 'data-section-settings' || 
               mutation.attributeName === 'data-shopify-editor-section')) {
            this.updateVisibilityFromSettings();
          }
        });
      });

      observer.observe(this.element, {
        attributes: true,
        attributeFilter: ['data-section-settings', 'data-shopify-editor-section']
      });
      this.observers.push(observer);

      // Poll for changes as a fallback
      const pollId = setInterval(() => {
        if (this.destroyed) return;
        this.updateVisibilityFromSettings();
      }, 1000);
      this.intervals.push(pollId);
    }

    updateVisibilityFromSettings() {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      const content = this.element.querySelector('.sticky-add-to-cart__content');
      if (!content) return;

      // Get current settings from the section
      const sectionSettings = this.getSectionSettings();
      
      // Update image visibility
      const imageElement = content.querySelector('.sticky-add-to-cart__image');
      if (imageElement) {
        // Remove existing mobile visibility classes
        imageElement.classList.remove('sticky-add-to-cart__image--hide-mobile');
        
        // Add mobile hide class if needed
        if (sectionSettings.show_image && !sectionSettings.show_image_mobile) {
          imageElement.classList.add('sticky-add-to-cart__image--hide-mobile');
        }
        
        // Overall image visibility
        imageElement.style.display = sectionSettings.show_image ? 'block' : 'none';
      }

      // Update title visibility
      const titleElement = content.querySelector('.sticky-add-to-cart__title');
      if (titleElement) {
        // Remove existing visibility classes
        titleElement.classList.remove('sticky-add-to-cart__title--hide-desktop', 'sticky-add-to-cart__title--hide-mobile');
        
        // Add appropriate classes based on settings
        if (!sectionSettings.show_title_desktop) {
          titleElement.classList.add('sticky-add-to-cart__title--hide-desktop');
        }
        if (!sectionSettings.show_title_mobile) {
          titleElement.classList.add('sticky-add-to-cart__title--hide-mobile');
        }
      }

      // Update variants visibility
      const variantsElement = content.querySelector('.sticky-add-to-cart__variants');
      if (variantsElement) {
        variantsElement.style.display = sectionSettings.show_variants ? 'block' : 'none';
        // Also update the variants display to refresh the change text
        if (sectionSettings.show_variants) {
          this.updateVariantsDisplay();
        }
      }

      // Update price visibility
      const priceElement = content.querySelector('.sticky-add-to-cart__price');
      if (priceElement) {
        priceElement.style.display = sectionSettings.show_price ? 'block' : 'none';
      }

      // Update image border radius
      this.updateImageBorderRadius(sectionSettings.image_border_radius);

      // Update layout classes
      this.updateLayoutClasses();
      
      // Update compact class
      this.updateCompactClass();
    }

    getSectionSettings() {
      // Try to get settings from various sources
      let settings = {};

      // Try to get from data attributes
      const settingsAttr = this.element.getAttribute('data-section-settings');
      if (settingsAttr) {
        try {
          settings = JSON.parse(settingsAttr);
        } catch (e) {
          // Fallback to default settings
        }
      }

      // Try to get from Shopify section data
      if (window.Shopify && window.Shopify.sections && this.element.dataset.sectionId) {
        const sectionData = window.Shopify.sections[this.element.dataset.sectionId];
        if (sectionData && sectionData.settings) {
          settings = { ...settings, ...sectionData.settings };
        }
      }

      // Default values
      return {
        show_image: settings.show_image !== false,
        show_image_mobile: settings.show_image_mobile !== false,
        show_title_desktop: settings.show_title_desktop !== false,
        show_title_mobile: settings.show_title_mobile !== false,
        show_variants: settings.show_variants !== false,
        show_price: settings.show_price !== false,
        show_on_desktop: settings.show_on_desktop !== false,
        show_on_mobile: settings.show_on_mobile !== false,
        show_at_top: settings.show_at_top || false,
        mobile_only_button: settings.mobile_only_button || false,
        mobile_no_padding: settings.mobile_no_padding || false,
        image_border_radius: settings.image_border_radius || 4,
        change_variant_text: settings.change_variant_text || 'Change',
        change_variant_link_enabled: settings.change_variant_link_enabled !== false,
        change_variant_link_style: settings.change_variant_link_style || (settings.change_variant_use_svg ? 'icon' : 'text'),
        compact: settings.compact || false,
        ...settings
      };
    }

    getChangeVariantText() {
      const settings = this.getSectionSettings();
      return settings.change_variant_text || 'Change';
    }

    updateLayoutClasses() {
      const content = this.element.querySelector('.sticky-add-to-cart__content');
      if (!content) return;

      const settings = this.getSectionSettings();

      // Update classes based on current visibility
      // For no-image class, consider both show_image and show_image_mobile
      // The CSS will handle the actual hiding, but we need to track if image should be considered "not present" for layout purposes
      const isMobile = window.innerWidth < 750;
      const imageVisibleOnCurrentDevice = settings.show_image && (isMobile ? settings.show_image_mobile : true);
      content.classList.toggle('no-image', !imageVisibleOnCurrentDevice);
      content.classList.toggle('no-title', !settings.show_title_desktop && !settings.show_title_mobile);
      content.classList.toggle('no-variants', !settings.show_variants);
      content.classList.toggle('no-price', !settings.show_price);
      
      // Add class for when title mobile is hidden (for fallback CSS)
      content.classList.toggle('has-title-mobile-hidden', !settings.show_title_mobile);
      
      // Add class for when all elements are hidden (for fallback CSS)
      const allElementsHidden = !imageVisibleOnCurrentDevice && !settings.show_title_desktop && !settings.show_title_mobile && !settings.show_variants && !settings.show_price;
      content.classList.toggle('all-elements-hidden', allElementsHidden);

    // Note: Full width button styling is now handled by CSS using :has() selector

      // Update desktop/mobile visibility classes
      this.element.classList.toggle('sticky-add-to-cart--hide-desktop', !settings.show_on_desktop);
      this.element.classList.toggle('sticky-add-to-cart--hide-mobile', !settings.show_on_mobile);
      this.element.classList.toggle('sticky-add-to-cart--mobile-only-button', settings.mobile_only_button);
      this.element.classList.toggle('sticky-add-to-cart--mobile-no-padding', settings.mobile_no_padding);
    }

    updateCompactClass() {
      const settings = this.getSectionSettings();
      
      // Toggle compact class based on setting
      this.element.classList.toggle('atc-compact', settings.compact);
    }

    updateImageBorderRadius(borderRadius) {
      const imageContainer = this.element.querySelector('.sticky-add-to-cart__image');
      const imageElement = this.element.querySelector('.sticky-add-to-cart__image img');
      
      if (imageContainer) {
        imageContainer.style.borderRadius = `${borderRadius || 4}px`;
      }
      
      if (imageElement) {
        imageElement.style.borderRadius = `${borderRadius || 4}px`;
      }
    }

    getChangeVariantSvg() {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" class="sticky-add-to-cart__change-icon" aria-hidden="true"><path d="M12 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V12M9 15V12.5L17.75 3.75C18.4404 3.05964 19.5596 3.05964 20.25 3.75V3.75C20.9404 4.44036 20.9404 5.55964 20.25 6.25L15.5 11L11.5 15H9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    updateVariantsDisplay() {
      const variantsElement = this.element.querySelector('[data-sticky-variants]');
      if (!variantsElement) return;

      // Get selected variants from the page
      const selectedVariants = this.getSelectedVariants();
      const settings = this.getSectionSettings();
      
      if (selectedVariants.length > 0) {
        const variantsHTML = selectedVariants.map(variant => variant.value).join(' / ');
        const linkEnabled = settings.change_variant_link_enabled;
        const useIcon = settings.change_variant_link_style === 'icon';
        
        if (linkEnabled) {
          const changeContent = useIcon ? this.getChangeVariantSvg() : this.getChangeVariantText();
          const linkTitle = useIcon ? ` title="${(this.getChangeVariantText()).replace(/"/g, '&quot;')}"` : '';
          variantsElement.innerHTML = `${variantsHTML} <a href="#" class="sticky-add-to-cart__variant-link" data-scroll-to-variants${linkTitle}>${changeContent}</a>`;
        } else {
          variantsElement.innerHTML = variantsHTML;
        }
      } else {
        variantsElement.innerHTML = '';
      }

      // Also update the image
      this.updateImage();
    }

    updateImageFromVariant(variant) {
      const imageElement = this.element.querySelector('[data-sticky-image] img');
      if (!imageElement) return;

      if (variant && variant.featured_media) {
        const section = document.querySelector('[data-sticky-add-to-cart]');
        const aspectRatio = section?.dataset.thumbnailAspectRatio || 'square';
        
        let dimensions;
        if (aspectRatio === 'adaptive') {
          dimensions = this.getAdaptiveImageDimensions(variant.featured_media);
        } else {
          dimensions = this.getThumbnailDimensions();
        }
        
        const imageUrl = this.getImageUrl(variant.featured_media, dimensions.width, dimensions.height);
        if (imageUrl) {
          imageElement.src = imageUrl;
          imageElement.alt = variant.featured_media.alt || `Variant ${variant.title} image`;
          imageElement.setAttribute('data-variant-image', variant.id || '');
          imageElement.removeAttribute('data-fallback-image');
          return;
        }
      }

      // Fallback to regular updateImage method
      this.updateImage();
    }

    updateImage() {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      const imageElement = this.element.querySelector('[data-sticky-image] img');
      if (!imageElement) return;

      // Try to get the selected variant image first
      const selectedVariantImage = this.getSelectedVariantImage();
      
      if (selectedVariantImage) {
        imageElement.src = selectedVariantImage.url;
        imageElement.alt = selectedVariantImage.alt || 'Selected variant image';
        imageElement.setAttribute('data-variant-image', selectedVariantImage.variantId || '');
        imageElement.removeAttribute('data-fallback-image');
      } else {
        // Fallback to featured image
        const featuredImage = this.getFeaturedImage();
        if (featuredImage) {
          imageElement.src = featuredImage.url;
          imageElement.alt = featuredImage.alt || 'Product featured image';
          imageElement.setAttribute('data-fallback-image', 'true');
          imageElement.removeAttribute('data-variant-image');
        }
      }
    }

    getSelectedVariantImage() {
      // First try to get the currently selected variant from the form
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      
      if (form) {
        const variantIdInput = form.querySelector('input[name="id"]');
        
        if (variantIdInput && variantIdInput.value) {
          const variantId = variantIdInput.value;
          
          // Try multiple sources for variant data
          let variantData = window.productVariants || window.product?.variants;
          
          // Try to get from form data
          if (!variantData && form.dataset.variants) {
            try {
              variantData = JSON.parse(form.dataset.variants);
            } catch (e) {
              // Could not parse form variant data
            }
          }
          
          // Try to get from product form component
          if (!variantData) {
            const productForm = document.querySelector('product-form-component');
            if (productForm && productForm.dataset.variants) {
              try {
                variantData = JSON.parse(productForm.dataset.variants);
              } catch (e) {
                // Could not parse product form variant data
              }
            }
          }
          
          if (variantData && Array.isArray(variantData)) {
            const variant = variantData.find(v => v.id == variantId);
            
            if (variant && variant.featured_media) {
              const section = document.querySelector('[data-sticky-add-to-cart]');
              const aspectRatio = section?.dataset.thumbnailAspectRatio || 'square';
              
              let dimensions;
              if (aspectRatio === 'adaptive') {
                dimensions = this.getAdaptiveImageDimensions(variant.featured_media);
              } else {
                dimensions = this.getThumbnailDimensions();
              }
              
              return {
                url: this.getImageUrl(variant.featured_media, dimensions.width, dimensions.height),
                alt: variant.featured_media.alt || `Variant ${variant.title} image`,
                variantId: variantId
              };
            }
          }
        }
      }

      // Fallback: check variant pickers
      const variantPickers = document.querySelectorAll('variant-picker');
      
      for (const picker of variantPickers) {
        const selectedInput = picker.querySelector('input:checked, select option:checked, select');
        
        if (selectedInput) {
          const variantId = selectedInput.dataset.variantId;
          if (variantId) {
            // Try to get variant data
            const variantData = window.productVariants || window.product?.variants;
            if (variantData) {
              const variant = variantData.find(v => v.id == variantId);
              if (variant && variant.featured_media) {
                const section = document.querySelector('[data-sticky-add-to-cart]');
                const aspectRatio = section?.dataset.thumbnailAspectRatio || 'square';
                
                let dimensions;
                if (aspectRatio === 'adaptive') {
                  dimensions = this.getAdaptiveImageDimensions(variant.featured_media);
                } else {
                  dimensions = this.getThumbnailDimensions();
                }
                
                return {
                  url: this.getImageUrl(variant.featured_media, dimensions.width, dimensions.height),
                  alt: variant.featured_media.alt || `Variant ${variant.title} image`,
                  variantId: variantId
                };
              }
            }
          }
        }
      }

      // Additional fallback: check for any selected variant options and try to find the corresponding variant
      const selectedOptions = this.getSelectedVariants();
      if (selectedOptions.length > 0) {
        const variantData = window.productVariants || window.product?.variants;
        if (variantData) {
          // Try to find a variant that matches the selected options
          const matchingVariant = variantData.find(variant => {
            return selectedOptions.every(option => {
              const optionName = option.name.toLowerCase();
              const optionValue = option.value.toLowerCase();
              
              // Check if this variant has the selected option
              if (optionName.includes('color') && variant.option1 && variant.option1.toLowerCase() === optionValue) return true;
              if (optionName.includes('size') && variant.option2 && variant.option2.toLowerCase() === optionValue) return true;
              if (optionName.includes('style') && variant.option3 && variant.option3.toLowerCase() === optionValue) return true;
              
              return false;
            });
          });
          
          if (matchingVariant && matchingVariant.featured_media) {
            const section = document.querySelector('[data-sticky-add-to-cart]');
            const aspectRatio = section?.dataset.thumbnailAspectRatio || 'square';
            
            let dimensions;
            if (aspectRatio === 'adaptive') {
              dimensions = this.getAdaptiveImageDimensions(matchingVariant.featured_media);
            } else {
              dimensions = this.getThumbnailDimensions();
            }
            
            return {
              url: this.getImageUrl(matchingVariant.featured_media, dimensions.width, dimensions.height),
              alt: matchingVariant.featured_media.alt || `Variant ${matchingVariant.title} image`,
              variantId: matchingVariant.id
            };
          }
        }
      }

      // Additional fallback: try to get image from main product display
      const mainImage = this.getCurrentMainImage();
      if (mainImage) {
        return mainImage;
      }

      return null;
    }

    getCurrentMainImage() {
      // Try to get the currently displayed image from the main product page
      const mainImageSelectors = [
        '.product-media img[data-variant-image]',
        '.media-gallery img[data-variant-image]',
        '.product-images img[data-variant-image]',
        '.product-media img:not([data-fallback-image])',
        '.media-gallery img:not([data-fallback-image])',
        '.product-images img:not([data-fallback-image])'
      ];

      for (const selector of mainImageSelectors) {
        const img = document.querySelector(selector);
        if (img && img.src) {
          return {
            url: img.src,
            alt: img.alt || 'Product image',
            variantId: img.dataset.variantImage || ''
          };
        }
      }

      return null;
    }

    getFeaturedImage() {
      // Get the product's featured image
      const productData = window.product || this.getProductFromPage();
      if (productData && productData.featured_media) {
        const section = document.querySelector('[data-sticky-add-to-cart]');
        const aspectRatio = section?.dataset.thumbnailAspectRatio || 'square';
        
        let dimensions;
        if (aspectRatio === 'adaptive') {
          dimensions = this.getAdaptiveImageDimensions(productData.featured_media);
        } else {
          dimensions = this.getThumbnailDimensions();
        }
        
        return {
          url: this.getImageUrl(productData.featured_media, dimensions.width, dimensions.height),
          alt: productData.featured_media.alt || 'Product featured image'
        };
      }

      return null;
    }

    getProductFromPage() {
      // Try to extract product data from the page
      const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
      if (productForm && productForm.dataset.product) {
        try {
          return JSON.parse(productForm.dataset.product);
        } catch (e) {
          // Could not parse product data
        }
      }

      return null;
    }

    getImageUrl(media, width, height) {
      if (!media) return null;
      
      let imageUrl = null;
      
      // Handle different media types
      if (media.preview_image) {
        // Generate image URL with Shopify's image transformation
        const baseUrl = media.preview_image.src || media.preview_image;
        
        if (baseUrl) {
          // Use Shopify's image transformation API
          const params = new URLSearchParams({
            width: width.toString(),
            height: height.toString(),
            crop: 'center'
          });
          imageUrl = `${baseUrl}?${params.toString()}`;
        }
      } else if (media.src) {
        imageUrl = media.src;
      } else if (typeof media === 'string') {
        imageUrl = media;
      } else if (media.url) {
        imageUrl = media.url;
      }
      
      return imageUrl;
    }

    getThumbnailDimensions() {
      // Get thumbnail dimensions from the section settings
      const section = document.querySelector('[data-sticky-add-to-cart]');
      if (!section) return { width: 40, height: 40 };
      
      const size = parseInt(section.dataset.thumbnailSize) || 40;
      const aspectRatio = section.dataset.thumbnailAspectRatio || 'square';
      
      let width, height;
      switch (aspectRatio) {
        case 'portrait':
          width = size;
          height = Math.round(size * 1.33);
          break;
        case 'landscape':
          width = Math.round(size * 1.33);
          height = size;
          break;
        case 'wide':
          width = Math.round(size * 1.78);
          height = size;
          break;
        case 'adaptive':
          // For adaptive mode, we use a square container but let the image maintain its aspect ratio
          width = size;
          height = size;
          break;
        default: // square
          width = size;
          height = size;
      }
      
      return { width, height };
    }

    getAdaptiveImageDimensions(media) {
      // For adaptive mode, try to get the original image dimensions
      if (!media) return this.getThumbnailDimensions();
      
      const section = document.querySelector('[data-sticky-add-to-cart]');
      const maxSize = parseInt(section?.dataset.thumbnailSize) || 40;
      
      // Try to get original dimensions from the media object
      let originalWidth = null;
      let originalHeight = null;
      
      if (media.preview_image) {
        originalWidth = media.preview_image.width;
        originalHeight = media.preview_image.height;
      } else if (media.width && media.height) {
        originalWidth = media.width;
        originalHeight = media.height;
      }
      
      if (originalWidth && originalHeight) {
        // Calculate dimensions that fit within the max size while maintaining aspect ratio
        const aspectRatio = originalWidth / originalHeight;
        
        let width, height;
        if (aspectRatio > 1) {
          // Landscape image
          width = maxSize;
          height = Math.round(maxSize / aspectRatio);
        } else {
          // Portrait or square image
          height = maxSize;
          width = Math.round(maxSize * aspectRatio);
        }
        
        return { width, height };
      }
      
      // Fallback to square if we can't determine dimensions
      return { width: maxSize, height: maxSize };
    }

    getSelectedVariants() {
      const variants = [];
      const addedOptions = new Set(); // Track added options to prevent duplicates
      
      // Find all variant pickers on the page
      const variantPickers = document.querySelectorAll('variant-picker');
      
      variantPickers.forEach(picker => {
        // Look for all checked inputs within this picker
        const checkedInputs = picker.querySelectorAll('input:checked, select option:checked');
        
        checkedInputs.forEach(selectedInput => {
          const optionName = picker.dataset.optionName || this.getOptionNameFromInput(selectedInput);
          const optionValue = selectedInput.value || selectedInput.textContent;
          
          if (optionName && optionValue) {
            const optionKey = `${optionName}:${optionValue}`.toLowerCase();
            if (!addedOptions.has(optionKey)) {
              variants.push({
                name: optionName,
                value: optionValue
              });
              addedOptions.add(optionKey);
            }
          }
        });
      });

      // Also check for form inputs
      const formInputs = document.querySelectorAll('form[data-type="add-to-cart-form"] input[name^="options"]');
      formInputs.forEach(input => {
        if (input.checked || input.type === 'hidden') {
          const optionName = input.name.replace('options[', '').replace(']', '');
          const optionValue = input.value;
          
          if (optionName && optionValue) {
            const optionKey = `${optionName}:${optionValue}`.toLowerCase();
            if (!addedOptions.has(optionKey)) {
              variants.push({
                name: optionName,
                value: optionValue
              });
              addedOptions.add(optionKey);
            }
          }
        }
      });

      // Additional fallback: look for any selected variant options in the DOM
      const allCheckedInputs = document.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked, select option:checked');
      allCheckedInputs.forEach(input => {
        // Skip if we already processed this input
        if (input.closest('variant-picker') || (input.name && input.name.startsWith('options['))) {
          return;
        }
        
        const optionName = this.getOptionNameFromInput(input);
        const optionValue = input.value || input.textContent;
        
        if (optionName && optionValue && optionName !== 'Option') {
          const optionKey = `${optionName}:${optionValue}`.toLowerCase();
          if (!addedOptions.has(optionKey)) {
            variants.push({
              name: optionName,
              value: optionValue
            });
            addedOptions.add(optionKey);
          }
        }
      });

      return variants;
    }

    getOptionNameFromInput(input) {
      // Try to get option name from various sources
      const label = input.closest('label');
      if (label) {
        const labelText = label.textContent.trim();
        const colonIndex = labelText.indexOf(':');
        if (colonIndex > 0) {
          return labelText.substring(0, colonIndex).trim();
        }
      }

      // Try to get from parent element
      const parent = input.closest('[data-option-name]');
      if (parent) {
        return parent.dataset.optionName;
      }

      // Try to get from fieldset legend
      const fieldset = input.closest('fieldset');
      if (fieldset) {
        const legend = fieldset.querySelector('legend');
        if (legend) {
          return legend.textContent.trim();
        }
      }

      return 'Option';
    }

    updatePriceFromVariantId(variantId) {
      // Try multiple ways to get variant data
      let variantData = window.productVariants || window.product?.variants;
      
      // If not found, try to get from the product form
      if (!variantData) {
        const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
        if (productForm) {
          variantData = JSON.parse(productForm.dataset.variants || '[]');
        }
      }

      // If still not found, try to get from the product information section
      if (!variantData) {
        const productInfo = document.querySelector('[data-testid="product-information-details"]');
        if (productInfo) {
          variantData = JSON.parse(productInfo.dataset.variants || '[]');
        }
      }

      if (!variantData) return;

      const variant = variantData.find(v => v.id == variantId);
      if (variant) {
        this.updatePrice(variant);
        this.updateVariantsDisplay();
      } else {
        this.updateVariantsDisplay();
      }
    }

    updatePriceFromVariantData(variantData) {
      if (variantData && variantData.variant) {
        this.updatePrice(variantData.variant);
      }
    }

    updatePriceFromForm(variantId) {
      // Find the variant data from the page
      const variantData = window.productVariants || window.product?.variants;
      if (!variantData) return;

      const variant = variantData.find(v => v.id == variantId);
      if (variant) {
        this.updatePrice(variant);
      }
    }

    updatePrice(variant) {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      const priceElement = this.element.querySelector('[data-sticky-price]');
      if (!priceElement) return;

      // Check if quantity breaks block is present and has an active card
      // If so, use price from quantity breaks instead of variant price (only if override is enabled in sticky-add-to-cart)
      const stickyOverrideEnabled = this.element.dataset.overrideProductPrice === 'true';
      if (stickyOverrideEnabled) {
        const quantityBreaksComponent = document.querySelector('[data-quantity-breaks-component]');
        if (quantityBreaksComponent) {
          const activeCard = quantityBreaksComponent.querySelector('.quantity-breaks__card--active');
          if (activeCard) {
            // Defer so quantity-breaks.js has updated its prices first (same variant:update event)
            setTimeout(() => this.updatePriceFromQuantityBreaks(), 0);
            return;
          }
        }
      }

      if (variant) {
        // When override is disabled, copy from main price (server-rendered, correct currency/format)
        // Defer so product-price.js has updated the main price from variant response first
        setTimeout(() => this.copyPriceFromMain(), 0);
      } else {
        this.copyPriceFromMain();
      }
    }

    copyPriceFromMain() {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      const priceElement = this.element.querySelector('[data-sticky-price]');
      if (!priceElement) return;

      // First check if quantity breaks price is available (only if override is enabled in sticky-add-to-cart)
      const stickyOverrideEnabled = this.element.dataset.overrideProductPrice === 'true';
      if (stickyOverrideEnabled) {
        const quantityBreaksComponent = document.querySelector('[data-quantity-breaks-component]');
        if (quantityBreaksComponent) {
          const activeCard = quantityBreaksComponent.querySelector('.quantity-breaks__card--active');
          if (activeCard) {
            this.updatePriceFromQuantityBreaks();
            return;
          }
        }
      }

      // Copy from main product price container (server-rendered, correct currency/format)
      // Main price is in product-information (or similar), not in this section
      const mainPriceContainer = document.querySelector('product-price [ref="priceContainer"]');
      if (mainPriceContainer) {
        const stickyPriceContainer = priceElement.querySelector('[ref="priceContainer"]') || priceElement;
        stickyPriceContainer.innerHTML = mainPriceContainer.innerHTML;
        // show_sale_badge: false — remove sale badge from sticky bar
        stickyPriceContainer.querySelector('.sale-badge')?.remove();
        this.updateVariantsDisplay();
        return;
      }

      // Fallback: try legacy selectors for single .price element
      const mainPriceSelectors = [
        '.product-details .price',
        '[data-testid="product-information-details"] .price',
        '.buy-buttons-block .price',
        'product-form-component .price'
      ];
      for (const selector of mainPriceSelectors) {
        const mainPrice = document.querySelector(selector);
        if (mainPrice) {
          priceElement.innerHTML = mainPrice.innerHTML;
          // show_sale_badge: false — remove sale badge from sticky bar
          priceElement.querySelector('.sale-badge')?.remove();
          this.updateVariantsDisplay();
          return;
        }
      }
    }

    setupPriceObserver() {
      // Watch for changes in the main price display
      const mainPriceSelectors = [
        '.product-details .price',
        '[data-testid="product-information-details"] .price',
        '.buy-buttons-block .price',
        'product-form-component .price'
      ];

      mainPriceSelectors.forEach(selector => {
        const mainPrice = document.querySelector(selector);
        if (mainPrice) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'childList' || mutation.type === 'characterData') {
                this.copyPriceFromMain();
              }
            });
          });

          observer.observe(mainPrice, {
            childList: true,
            subtree: true,
            characterData: true
          });

        }
      });
    }

    updatePriceDisplay(priceData) {
      const priceElement = this.element.querySelector('[data-sticky-price]');
      if (!priceElement || !priceData) return;

      // Update with the provided price data
      priceElement.innerHTML = priceData.html || priceData;
    }

    formatPrice(variant) {
      if (!variant) return '';

      const price = variant.price;
      const compareAtPrice = variant.compare_at_price;
      const priceEl = this.element?.querySelector('[data-sticky-price]');
      const showSaleFirst = !priceEl || priceEl.dataset.showSalePriceFirst !== 'false';
      const fmt = (c) =>
        typeof Theme !== 'undefined' && Theme.formatPriceSplitHTML
          ? Theme.formatPriceSplitHTML(c, false, 'upsells')
          : this.formatMoney(c);

      const sale = `<span class="price">${fmt(price)}</span>`;
      if (compareAtPrice && compareAtPrice > price) {
        const cmp = `<span class="compare-at-price price--compare">${fmt(compareAtPrice)}</span>`;
        return showSaleFirst ? `${sale}${cmp}` : `${cmp}${sale}`;
      }
      return sale;
    }

    formatMoney(cents) {
      if (!this.element) return '';
      const amount = cents / 100;
      const moneyFormat = this.element.dataset.moneyFormat ||
        (typeof window.Theme !== 'undefined' && window.Theme.moneyFormat);
      const currency = this.element.dataset.currency ||
        (typeof window.Theme !== 'undefined' && window.Theme.currency) || 'USD';
      if (moneyFormat) {
        const formatted = amount.toFixed(2);
        const rounded = String(Math.round(amount));
        const withComma = amount.toFixed(2).replace('.', ',');
        let result = moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/g, formatted)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, rounded)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, rounded)
          .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withComma)
          .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, formatted.replace('.', "'"))
          .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, rounded)
          .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, formatted);
        return result.replace(/<[^>]+>/g, '').trim();
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    }

    updateVisibility() {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Get section settings to check if it's positioned at top
      const settings = this.getSectionSettings();
      const isAtTop = settings.show_at_top;
      
      // Check scroll position based on sticky cart position
      if (isAtTop) {
        // If positioned at top, hide when scrolled to top
        const isAtTopOfPage = scrollY <= 10; // 10px tolerance
        if (isAtTopOfPage) {
          this.element.classList.remove('sticky-add-to-cart--visible');
          return;
        }
        
        // If positioned at top, show when scrolled to bottom
        const isAtBottom = (scrollY + windowHeight) >= (documentHeight - 10); // 10px tolerance
        if (isAtBottom) {
          this.element.classList.add('sticky-add-to-cart--visible');
          return;
        }
      } else {
        // If positioned at bottom, hide when scrolled to bottom
        const isAtBottom = (scrollY + windowHeight) >= (documentHeight - 10); // 10px tolerance
        if (isAtBottom) {
          this.element.classList.remove('sticky-add-to-cart--visible');
          return;
        }
      }

      // Check if main add to cart button is visible
      const mainButtonVisible = this.isMainAddToCartVisible();

      // MyEssencìl : par défaut (« after_button »), la barre n'apparaît qu'une fois le bouton principal
      // entièrement dépassé vers le haut, jamais au chargement quand ce bouton est encore plus bas dans la page.
      // « not_visible » = comportement Booster d'origine (dès que le bouton n'est pas à l'écran).
      const trigger = settings.show_trigger || 'after_button';
      const mainRect = this.mainAddToCartButton ? this.mainAddToCartButton.getBoundingClientRect() : null;
      const mainRendered = mainRect && (mainRect.width > 0 || mainRect.height > 0);
      let show;
      if (trigger === 'not_visible') {
        show = (!mainButtonVisible && this.mainAddToCartButton) || !this.mainAddToCartButton;
      } else if (mainRendered) {
        show = mainRect.bottom < 0;
      } else {
        // Pas de bouton principal affiché : apparition après une demi-hauteur d'écran de défilement
        show = scrollY > windowHeight / 2;
      }

      if (show) {
        this.element.classList.add('sticky-add-to-cart--visible');
      } else {
        this.element.classList.remove('sticky-add-to-cart--visible');
      }
    }

    setupScrollListener() {
      let ticking = false;
      
      const updateVisibility = () => {
        this.updateVisibility();
        ticking = false;
      };

      const requestTick = () => {
        if (!ticking) {
          requestAnimationFrame(updateVisibility);
          ticking = true;
        }
      };

      window.addEventListener('scroll', requestTick, { passive: true });
      
      // Also check on resize in case viewport changes
      window.addEventListener('resize', () => {
        requestTick();
        // Update layout classes on resize to handle mobile/desktop image visibility
        this.updateLayoutClasses();
      }, { passive: true });
      
      // Re-scan for main button periodically in case it loads dynamically
      const scanId = setInterval(() => {
        if (this.destroyed) return;
        const newMainButton = this.findMainAddToCartButton();
        if (newMainButton !== this.mainAddToCartButton) {
          // Clean up old animation observer
          if (this.animationObserver) {
            this.animationObserver.disconnect();
          }
          
          this.mainAddToCartButton = newMainButton;
          // Sync state when main button changes
          this.syncButtonState();
          // Re-setup animation sync for new button
          this.setupAnimationSync();
        }
      }, 2000);
      this.intervals.push(scanId);
    }
  }

  // Make StickyAddToCart available globally for morph callbacks
  window.StickyAddToCart = StickyAddToCart;

  function initStickyAddToCart() {
    if (window.stickyAddToCartInstance) {
      window.stickyAddToCartInstance.destroy();
    }
    window.stickyAddToCartInstance = new StickyAddToCart();
  }

  function isStickyAddToCartSection(target) {
    return target && target.querySelector && target.querySelector('[data-sticky-add-to-cart]');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initStickyAddToCart());
  } else {
    initStickyAddToCart();
  }

  // Re-initialize when section is replaced in theme editor (e.g. after settings change)
  document.addEventListener('shopify:section:load', (event) => {
    if (isStickyAddToCartSection(event.target)) {
      initStickyAddToCart();
    }
  });
  document.addEventListener('shopify:theme:section:load', (event) => {
    if (isStickyAddToCartSection(event.target)) {
      initStickyAddToCart();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
